import React, { useState, useEffect } from "react";
import "./App.css"; // Create this file for styling
// import A1_1 from "./string/A1/A1.1/A1.1.json";
// import A1_2 from "./string/A1/A1.2/A1.2.json";
// import A2_1 from "./string/A2/A2.1/A2.1.json";
import {
  Button,
  FormControl,
  Input,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import VisibilityIcon from "@mui/icons-material/Visibility";
const App = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  const levels = ["A1.1", "A1.2", "A2.1", "A2.2"];
  const leks = Array.from({ length: 12 }, (_, i) => `lek${i + 1}`);
  const wordTypes = ["Substantiv", "Verben", "adjectives"];

  const [wordsArray, setWordsArray] = useState([]);
  const [userAnswers, setUserAnswers] = useState({});
  const [score, setScore] = useState(0);
  const [showAnswers, setShowAnswers] = useState({}); // Object to track visibility of answers

  const [selectedLek, setSelectedLek] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedWordType, setSelectedWordType] = useState("");
  useEffect(() => {
    const importJsonFiles = async () => {
      if (selectedLek && selectedLevel) {
        const filePath = `./string/${selectedLevel}/${selectedLek}.json`;
        try {
          console.log(`Trying to import: ${filePath}`);
          const data = await import(`${filePath}`);
          const lekData = data?.default;

          if (lekData && selectedLek && selectedWordType) {
            setWordsArray(
              Object.entries(lekData[selectedLek][selectedWordType])
            );
            // console.log(lekData[selectedLek][selectedWordType]);
          } else {
            setWordsArray([]);
          }
        } catch (error) {
          console.error("Error importing JSON file:", error);
          setWordsArray([]);
        }
      } else {
        setWordsArray([]);
      }
    };

    importJsonFiles();
  }, [selectedLek, selectedLevel, selectedWordType]);

  const handleChange = (wordKey, value) => {
    setUserAnswers({ ...userAnswers, [wordKey]: value });
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    let newScore = 0;

    wordsArray.forEach(([wordKey, wordData]) => {
      const userAnswer = userAnswers[wordKey]?.toLowerCase();
      const correctAnswer = wordKey.toLowerCase(); // Compare with wordKey instead of wordKey
      if (userAnswer === correctAnswer) {
        newScore++;
      }
    });

    setScore(newScore);
    setShowAnswers({}); // Reset visibility of answers on submit
  };

  const toggleAnswer = (wordKey) => {
    setShowAnswers((prev) => ({
      ...prev,
      [wordKey]: !prev[wordKey], // Toggle the answer visibility
    }));
  };

  return (
    <Stack className="App" spacing={3} sx={{ width: "100%", margin: "0" }}>
      {/* <Typography
        sx={{
          width: "100%",
          padding: "12px",
          background: "gray ",
          color: "white",
        }}
        variant="h7"
      >
        هذا الموقع سوف يساعدك على حفظ الكلمات الألمانية. إذا كان مفيدًا لك، أطلب
        منك التكرم بالدعاء.
      </Typography> */}
      <Typography variant="h4">German Word Practice</Typography>

      <Stack
        sx={{
          flexDirection: "row",
          gap: "20px",
        }}
      >
        <FormControl
          fullWidth
          sx={{
            minWidth: "104px",
          }}
        >
          <InputLabel id="select-level">Level</InputLabel>
          <Select
            label="Level"
            labelId="select-level"
            value={selectedLevel}
            onChange={(e) => setSelectedLevel(e.target.value)}
          >
            {levels.map((level) => (
              <MenuItem key={level} value={level}>
                {level}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          fullWidth
          sx={{
            minWidth: "104px",
          }}
        >
          <InputLabel id="select-lek">lektion</InputLabel>
          <Select
            labelId="select-lek"
            label="Lek"
            value={selectedLek}
            onChange={(e) => setSelectedLek(e.target.value)}
          >
            {leks.map((lek) => (
              <MenuItem key={lek} value={lek}>
                {lek}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl
          fullWidth
          sx={{
            minWidth: "104px",
          }}
        >
          <InputLabel id="select-type">Type</InputLabel>
          <Select
            label="Word Type"
            labelId="select-type"
            value={selectedWordType}
            onChange={(e) => setSelectedWordType(e.target.value)}
          >
            {wordTypes.map((type) => (
              <MenuItem key={type} value={type}>
                {type}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Stack>

      <Stack
        sx={{
          margin: "0 auto",
          // width: "100%",
        }}
      >
        <form
          onSubmit={handleSubmit}
          className="from1"
          // style={{ width: "100%" }}
        >
          {wordsArray.map(([wordKey, wordData], index) => (
            <Stack
              key={index}
              className="word-pair"
              spacing={2}
              alignItems="center"
              sx={{
                flexDirection: "column",
                gap: "8px",
                marginBottom: isMobile ? "12px" : "24px",
                borderBottom: isMobile ? "2px solid black" : "",
                justifyContent: "center",
                // width: "100%",
              }}
            >
              <Stack
                sx={{
                  flexDirection: isMobile ? "column" : "row",
                  gap: isMobile ? "8px" : "54px",
                  // marginBottom: isMobile ? "12px" : "24px",
                  // borderBottom: isMobile ? "2px solid black" : "",
                  justifyContent: isMobile ? "center" : "flex-start",
                  flexWrap: "wrap",
                  position: "relative",
                }}
              >
                <Typography width={"304px"}>
                  {wordData[2]} .........{wordData[1]}{" "}
                  {/* Arabic translation */}
                </Typography>
                <Stack
                  flexDirection="row"
                  alignItems={"center"}
                  justifyContent={"center"}
                  gap={"2px"}
                  sx={{
                    margin: "0 !important",
                  }}
                >
                  <Input
                    type="text"
                    value={userAnswers[wordKey] || ""}
                    onChange={(e) => handleChange(wordKey, e.target.value)}
                    className={
                      userAnswers[wordKey]?.toLowerCase() ===
                      wordKey?.toLowerCase()
                        ? "correct"
                        : "wrong"
                    }
                    sx={{
                      margin: "0",
                      marginTop: "0 !important",
                    }}
                  />
                  <VisibilityIcon
                    sx={{
                      margin: "0 !important",
                    }}
                    onClick={() => toggleAnswer(wordKey)}
                  ></VisibilityIcon>
                </Stack>
                {/* {showAnswers[wordKey] && (  */}
                <Typography
                  sx={{
                    background: "lightgray",
                    padding: "8px",
                    borderRadius: "12px",
                    marginTop: "0 !important",
                    visibility: showAnswers[wordKey] ? "visible" : "hidden",
                    position: isMobile ? "relative" : "absolute",
                    top: "0",
                    right: isMobile ? "" : "-15px",
                    transform: isMobile ? "" : "translateX(100%)",
                  }}
                >
                  {wordData[0]}
                </Typography>
                {/* )} */}
              </Stack>

              {/* example */}
              <Typography
                sx={{
                  marginTop: "0 !important",
                  marginBottom: "12px !important",
                  color: "green",
                }}
              >
                {userAnswers[wordKey]?.toLowerCase() === wordKey?.toLowerCase()
                  ? wordData[3].includes("..") || wordData[3].includes("__")
                    ? wordData[4]
                      ? wordData[4]
                      : wordData[3]
                    : wordData[3]
                  : wordData[3].includes("..") || wordData[3].includes("__")
                  ? wordData[3]
                  : ""}

                {/* Example sentence */}
              </Typography>
            </Stack>
          ))}
          <Button
            sx={{
              margin: "0 auto",
              background: "gray",
              marginTop: "54px",
              color: "black",
            }}
            type="submit"
          >
            Check Answers
          </Button>
        </form>
      </Stack>

      <h2>
        Your Score: {score}/{wordsArray.length}
      </h2>
    </Stack>
  );
};

export default App;
